import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  onboardClientRequest,
  signInUser,
  updateClientRequest,
  _signInUser,
  _signUpUser
} from 'src/api/AuthRequest';
import { AUTH_USER, SIGNIN_SUCCESS } from '../types';
import { requestWrapper } from 'src/utils/utils';
import { checkRequestError } from '.';

export const loginUser = (obj) => {
  return async (dispatch) => {
    try {
      const { data } = await signInUser(requestWrapper(obj));
      checkRequestError(data);

      sessionStorage.setItem('token', data.content.token);
      // sessionStorage.setItem(
      //   'companyProfile',
      //   JSON.stringify(data.content.company[0])
      // );
      sessionStorage.setItem('profile', JSON.stringify(data.content.data));
      dispatch({ type: SIGNIN_SUCCESS, payload: data.content });
      NotificationManager.success(data.success.message, 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const onboardClientAction = (payload) => {
  return async (dispatch) => {
    try {
      const { data } = await onboardClientRequest(requestWrapper(payload));

      checkRequestError(data);

      NotificationManager.success(data.success.message, 'Success');
      return { message: data.success.message, status: 1 };
    } catch (error) {
      NotificationManager.error(error.message, 'Error');
      return { message: error.message, status: 0 };
    }
  };
};

export const updateClientAction = (id, payload) => async (dispatch) => {
  try {
    const { data } = await updateClientRequest(id, requestWrapper(payload));

    checkRequestError(data);

    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const logoutUser = () => {
  return (dispatch) => {
    try {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('companyProfile');
      sessionStorage.removeItem('profile');
      sessionStorage.clear();
      // delete axios.defaults.headers['Authorization'];
      NotificationManager.info('Logout Successful', 'Success');
      return 1;
    } catch (error) {
      console.log('logout error', error);
    }
  };
};
